import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();
export interface Realtor {
  isvalid: boolean;
  token: string | null;
  deal_types: string[];
  header: {
    logo: string | null;
    text: string | null;
  };
  display:{
    title:boolean;
    result_url:boolean;
  };
  required: {
    email: boolean;
    name: boolean;
    phone: boolean;
  };
  link: {
    privacy_policy: string;
    access: string;
  };
  color: {
    main: string;
    sub: string;
  };
}
export const RealtorState = atom<Realtor>({
  key: "realtorState",
  default: {
    isvalid: false,
    token: null,
    deal_types: ["sale"],
    header: {
      logo: null,
      text: "AI不動産査定",
    },
    required: {
      email: true,
      name: true,
      phone: true,
    },
    display:{
      title: true,
      result_url:true,
    },
    link: {
      privacy_policy: "https://www.pricehubble.com/jp/privacy/privacy-policy/",
      access: "https://www.pricehubble.com/jp/privacy/privacy-policy/",
    },
    color: {
      main: "#0869BE",
      sub: "#afcde8",
      // main: "#be1708",
      // sub: "#e8b8af",
    },
  },
  effects_UNSTABLE: [persistAtom],
});
